(function() {
    'use strict';

    // --- IUBENDA HELPER PER DRAWER ---
function sendIubendaDrawerConsent() {
      try {
        var emailInput = document.getElementById('YomiRegEmail');
        if (!emailInput || !emailInput.value) return;

        var pEmail = document.getElementById('pref-email-newsletter') ? document.getElementById('pref-email-newsletter').checked : false;
        var pSms   = document.getElementById('pref-sms-marketing') ? document.getElementById('pref-sms-marketing').checked : false;
        var pWa    = document.getElementById('pref-whatsapp-marketing') ? document.getElementById('pref-whatsapp-marketing').checked : false;

        window._iub = window._iub || {};
        window._iub.cons_instructions = window._iub.cons_instructions || [];

        window._iub.cons_instructions.push(["submit", {
          consent: {
            subject: {
              email: emailInput.value
            },
            preferences: {
              privacy_policy: true, // Questo è fondamentale per Iubenda
              newsletter: pEmail,
              sms_marketing: pSms,
              whatsapp_marketing: pWa
            },
            // AGGIUNGI QUESTO BLOCCO: è quello che causa l'errore "error send data" se manca
            legal_notices: [
              { identifier: 'privacy_policy' },
              { identifier: 'newsletter' }
            ],
            proofs: [
              { content: "Registration via Account Drawer", form: "YomiAccountDrawer" }
            ]
          }
        }]);
        console.log("[YOMI] Iubenda consent sent successfully for: " + emailInput.value);
      } catch (e) {
        console.error("[YOMI] Iubenda sending error:", e);
      }
    }    // ---------------------------------
    
    // Open drawer
    window.openAccountDrawer = function() {
      var d = document.getElementById('YomiAccountDrawer');
      if(!d) return;
      try {
        var mount = document.getElementById('mountHere');
        if(mount) {
          // store whether it was already hidden so we can restore state later
          mount.dataset.yomiWasHidden = mount.hasAttribute('hidden') ? '1' : '0';
          mount.hidden = true;
        }
      } catch(e) {}
      // hide floating input iframe elements (specific chat widget) by class
      try {
        var floats = document.querySelectorAll('.floating-input-iframe-8l014i');
        if(floats && floats.length) {
          floats.forEach(function(el, idx){
            try {
              el.dataset.yomiOrigDisplay = el.style.display || '';
              el.style.display = 'none';
            } catch(e){}
          });
        }
      } catch(e) {}
      // Add a scoped CSS rule to forcibly hide matching floating/chat elements while drawer open
      try {
        if(!document.getElementById('yomi-hide-floating-style')){
          var s = document.createElement('style');
          s.id = 'yomi-hide-floating-style';
          s.appendChild(document.createTextNode('body.yomi-menu-open .floating-input-iframe-8l014i, body.yomi-menu-open iframe[src*="gorgias"], body.yomi-menu-open iframe[class*="gorgias"], body.yomi-menu-open iframe[id*="gorgias"], body.yomi-menu-open iframe[class*="widget-md"], body.yomi-menu-open .widget-md, body.yomi-menu-open [id^="gorgias-chat"], body.yomi-menu-open [id^="gorgias-web"], body.yomi-menu-open iframe[src*="floating-input"] { display: none !important; visibility: hidden !important; }'));
          document.head.appendChild(s);
        }
      } catch(e) {}
      // Also hide any iframes that may contain the chat widget (these are unaffected by parent CSS)
      try {
        var chatIframes = [];
        try { chatIframes = Array.prototype.slice.call(document.querySelectorAll('#mountHere iframe, iframe[src*="gorgias"], iframe[src*="floating-input"], iframe[data-gorgias-widget], iframe[class*="gorgias"], iframe[id*="gorgias"], iframe[class*="widget-md"]')); } catch(e) { chatIframes = []; }
        chatIframes.forEach(function(iframe){
          try {
            iframe.dataset.yomiOrigDisplay = iframe.style.getPropertyValue('display') || '';
            iframe.style.setProperty('display', 'none', 'important');
            iframe.dataset.yomiHiddenByYomi = '1';
          } catch(e){}
        });
      } catch(e) {}
      d.style.display = 'block';
      setTimeout(function() { d.classList.add('active'); }, 10);
      document.body.style.overflow = 'hidden';
      // mark body so our scoped CSS can hide chat widgets
      try { document.body.classList.add('yomi-menu-open'); } catch(e) {}
    };
    
    // Close drawer
    window.closeAccountDrawer = function() {
      var d = document.getElementById('YomiAccountDrawer');
      if(!d) return;
      d.classList.remove('active');
      setTimeout(function() { 
        d.style.display = 'none'; 
        document.body.style.overflow = ''; 
        try { document.body.classList.remove('yomi-menu-open'); } catch(e) {}
        try {
          var mount = document.getElementById('mountHere');
          if(mount) {
            if(mount.dataset.yomiWasHidden === '1') {
              mount.hidden = true;
            } else {
              mount.hidden = false;
            }
            try { delete mount.dataset.yomiWasHidden; } catch(e) { mount.removeAttribute('data-yomi-was-hidden'); }
          }
        } catch(e) {}
        // restore floating input iframe display
        try {
          var floats = document.querySelectorAll('.floating-input-iframe-8l014i');
          if(floats && floats.length) {
            floats.forEach(function(el){
              try {
                el.style.display = el.dataset.yomiOrigDisplay || '';
                try { delete el.dataset.yomiOrigDisplay; } catch(e) { el.removeAttribute('data-yomi-orig-display'); }
              } catch(e){}
            });
          }
        } catch(e) {}
        // remove the forced-hide CSS rule if present
        try {
          var s = document.getElementById('yomi-hide-floating-style');
          if(s) s.parentNode.removeChild(s);
        } catch(e) {}
        // restore any hidden chat iframes
        try {
          var chatIframes = [];
          try { chatIframes = Array.prototype.slice.call(document.querySelectorAll('iframe[data-yomi-hidden-by-yomi], #mountHere iframe, iframe[src*="gorgias"], iframe[src*="floating-input"], iframe[data-gorgias-widget], iframe[class*="gorgias"], iframe[id*="gorgias"], iframe[class*="widget-md"]')); } catch(e) { chatIframes = []; }
          chatIframes.forEach(function(iframe){
            try {
              if(iframe.dataset.yomiHiddenByYomi === '1') {
                var prev = iframe.dataset.yomiOrigDisplay || '';
                if(prev) {
                  iframe.style.setProperty('display', prev);
                } else {
                  iframe.style.removeProperty('display');
                }
                try { delete iframe.dataset.yomiOrigDisplay; } catch(e) { iframe.removeAttribute('data-yomi-orig-display'); }
                try { delete iframe.dataset.yomiHiddenByYomi; } catch(e) { iframe.removeAttribute('data-yomi-hidden-by-yomi'); }
              }
            } catch(e){}
          });
        } catch(e) {}
      }, 400);
    };
    
    // Switch views (includes Preferences)
    window.yomiSwitch = function(view) {
      var login = document.getElementById('YomiLoginView');
      var register = document.getElementById('YomiRegisterForm') ? document.getElementById('YomiRegisterView') : document.getElementById('YomiRegisterView');
      var forgot = document.getElementById('YomiForgotView');
      var prefs = document.getElementById('YomiPreferencesView');
      if(login) login.classList.toggle('active', view === 'Login');
      if(register) register.classList.toggle('active', view === 'Register');
      if(forgot) forgot.classList.toggle('active', view === 'Forgot');
      if(prefs) prefs.classList.toggle('active', view === 'Preferences');
    };
    
    // Password strength
    window.checkPasswordStrength = function(p, barId, textId) {
      barId = barId || 'YomiPwBar';
      textId = textId || 'YomiPwStrengthText';
      console.log('[YOMI] checkPasswordStrength called', { barId: barId, textId: textId, length: (p||'').length });
      var s = 0;
      if (!p) p = '';
      if(p.length > 5) s++;
      if(p.length > 8) s++;
      if(/[A-Z]/.test(p)) s++;
      if(/[0-9]/.test(p)) s++;
      console.log('[YOMI] strength score', s);
      var bar = document.getElementById(barId);
      var text = document.getElementById(textId);
      var colors = ['#ff4d4d', '#f5c242', '#EB5D5B', '#EB5D5B'];
      var labels = ['Weak', 'Fair', 'Good', 'Strong'];
      if(bar) {
        console.log('[YOMI] pw bar element found', barId, bar);
        try { console.log('[YOMI] pw bar rect', bar.getBoundingClientRect(), 'computed', window.getComputedStyle(bar)); } catch(e) {}
        bar.className = 'yomi-pw-bar';
        var width = s > 0 ? (s * 25) : 0;
        // set width and background-color with important to ensure visibility over other rules
        try {
          // First try percentage (original approach)
          bar.style.setProperty('width', width + '%', 'important');
          // Also ensure visible display/opacity
          bar.style.setProperty('display', 'block', 'important');
          bar.style.setProperty('opacity', '1', 'important');
          // compute container size and also set pixel fallback if percent doesn't produce layout
          var container = bar.closest('.yomi-pw-strength') || bar.parentElement;
          try { console.log('[YOMI] pw container rect', container && container.getBoundingClientRect()); } catch(e) {}
          var cWidth = (container && (container.clientWidth || (container.getBoundingClientRect && container.getBoundingClientRect().width))) || 0;
          var px = Math.round((width / 100) * cWidth);
          if(cWidth && px > 0) {
            bar.style.setProperty('width', px + 'px', 'important');
          }
          if(s > 0) {
            bar.style.setProperty('background-color', colors[s-1], 'important');
            bar.style.removeProperty('background-image');
            console.log('[YOMI] set bar', barId, 'width', width + '%', 'or', px + 'px', 'color', colors[s-1]);
          } else {
            bar.style.removeProperty('background-color');
            bar.style.removeProperty('background-image');
            console.log('[YOMI] cleared bar styles for', barId);
          }
        } catch(e) {
          // fallback
          bar.style.width = width + '%';
          bar.style.background = s > 0 ? colors[s-1] : '';
        }
      }
      if(text) {
        text.textContent = s > 0 ? labels[s-1] : '';
        text.style.cssText = s > 0 ? 'color: ' + colors[s-1] + ' !important;' : '';
      }
    };
    
    // Toggle password visibility
    window.togglePassword = function(inputId, btn) {
      var input = document.getElementById(inputId);
      if(!input) return;
      if(input.type === 'password') {
        input.type = 'text';
        btn.style.opacity = '0.5';
      } else {
        input.type = 'password';
        btn.style.opacity = '1';
      }
    };
    
    // Format birthday as DD/MM/YYYY
    window.formatBirthday = function(input) {
      var value = input.value.replace(/\D/g, '');
      var formatted = '';
      
      if(value.length > 0) {
        // Day
        var day = value.substring(0, 2);
        if(day.length === 2 && parseInt(day) > 31) day = '31';
        if(day.length === 2 && parseInt(day) === 0) day = '01';
        formatted = day;
      }
      if(value.length > 2) {
        // Month
        var month = value.substring(2, 4);
        if(month.length === 2 && parseInt(month) > 12) month = '12';
        if(month.length === 2 && parseInt(month) === 0) month = '01';
        formatted += '/' + month;
      }
      if(value.length > 4) {
        // Year
        var year = value.substring(4, 8);
        formatted += '/' + year;
      }
      
      input.value = formatted;
    };
    
    // Create account validation
    window.yomiValidateRegister = function(e) {
      var email = document.getElementById('YomiRegEmail').value.trim();
      var password = document.getElementById('YomiRegPass').value;
      var firstName = document.getElementById('YomiRegFirstName').value.trim();
      var lastName = document.getElementById('YomiRegLastName').value.trim();
      // privacy/terms are collected later in Preferences view
      
      var msg = document.getElementById('YomiRegisterMsg');
      
      // Validazione
      var errors = [];
      if(!email) errors.push('Email is required');
      else {
        // basic email format check
        var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if(!re.test(email)) errors.push('Please enter a valid email address');
      }
      if(!password) errors.push('Password is required');
      if(password.length < 5) errors.push('Password must be at least 5 characters');
      if(!firstName) errors.push('First name is required');
      if(!lastName) errors.push('Last name is required');
      // these checks are deferred to Preferences
      
      // Clear previous inline errors
      var emailErrEl = document.getElementById('YomiRegEmailError');
      if(emailErrEl) { emailErrEl.textContent = ''; emailErrEl.classList.remove('active'); }
      if(errors.length > 0) {
        e.preventDefault();
        // show email-specific error under the email input if present
        var emailSpecific = null;
        errors.forEach(function(err){ if(/email/i.test(err)) emailSpecific = err; });
        if(emailSpecific && emailErrEl) {
          emailErrEl.textContent = emailSpecific;
          emailErrEl.classList.add('active');
        }
        // show aggregated message for other errors
        var other = errors.filter(function(er){ return !/email/i.test(er); });
        if(other.length > 0 && msg) {
          msg.style.display = 'block';
          msg.style.background = '#f8d7da';
          msg.style.color = '#721c24';
          msg.style.border = '1px solid #f5c6cb';
          msg.innerHTML = other.join('<br>');
        }
        return false;
      }
      
      // Form valido — actual submit will be performed only after Preferences confirmation.
      return true;
    };
    
    // Attach validation to form and set timestamp on submit. Open preferences view
    // instead of submitting immediately; final submit happens after preferences confirm.
    document.addEventListener('DOMContentLoaded', function() {
      // Disable browser autocomplete for drawer forms/inputs to avoid intrusive suggestions
      try {
        var drawerEls = document.querySelectorAll('#YomiAccountDrawer form, #YomiAccountDrawer input, #YomiAccountDrawer textarea');
        drawerEls.forEach(function(el){ if(el && el.setAttribute) el.setAttribute('autocomplete','off'); });
        ['YomiRegEmail','YomiRegPass','YomiLoginPass','YomiForgotEmail','YomiRegFirstName','YomiRegLastName','YomiBirthday'].forEach(function(id){
          var e = document.getElementById(id); if(e && e.setAttribute) e.setAttribute('autocomplete','off');
        });
      } catch(e) {}

      var regForm = document.getElementById('YomiRegisterForm');
      if(regForm) {
        // When user clicks CREATE ACCOUNT, validate fields. If valid, open preferences view.
        // Use a dataset flag `yomiConfirmed` so we only allow the final submit after user confirms Preferences.
        regForm.addEventListener('submit', function(e) {
          console.log('[YOMI] regForm submit handler fired');
          // If the form was flagged as confirmed, allow native submit and clear the flag
          if (regForm.dataset.yomiConfirmed === 'true') {
            console.log('[YOMI] form already confirmed, allowing native submit');
            delete regForm.dataset.yomiConfirmed;
            return true;
          }

          // compute timestamp anyway and store temporarily
          try {
            var now = new Date();
            var timestamp = now.toLocaleString('it-IT', { timeZone: 'UTC' }) + ' UTC';
            var tsField = document.getElementById('yomi-timestamp-note');
            if(tsField) tsField.value = timestamp;
          } catch (err) { }

          // Run existing validation
          if(!window.yomiValidateRegister) {
            console.log('[YOMI] yomiValidateRegister not present, preventing submit');
            e.preventDefault(); e.stopImmediatePropagation(); return false;
          }
          var res = window.yomiValidateRegister(e);
          // If validation failed, yomiValidateRegister already prevented default and showed errors.
          // If validation passed (returns true), prevent immediate submit and open preferences.
          if(res === true) {
            console.log('[YOMI] register validation passed, opening Preferences');
            e.preventDefault();
            e.stopImmediatePropagation();
            // store pending form reference
            window._yomiPendingRegisterForm = regForm;
            // ensure drawer is open
            if(!document.getElementById('YomiAccountDrawer').classList.contains('active')) {
              window.openAccountDrawer();
              setTimeout(function(){ window.yomiSwitch('Preferences'); }, 300);
            } else {
              window.yomiSwitch('Preferences');
            }
          } else {
            // validation failed -> ensure other submit handlers don't run
            e.preventDefault(); e.stopImmediatePropagation();
          }
        });
      }

      // Clear inline errors on email input
      var emailInputEl = document.getElementById('YomiRegEmail');
      if(emailInputEl) {
        emailInputEl.addEventListener('input', function(){
          var emailErr = document.getElementById('YomiRegEmailError');
          if(emailErr) { emailErr.textContent = ''; emailErr.classList.remove('active'); }
          var msg = document.getElementById('YomiRegisterMsg'); if(msg) { msg.style.display = 'none'; }
        });
      }

      // Change CREATE ACCOUNT behavior: do not submit directly, validate and open Preferences
      var regBtnEl = document.getElementById('YomiRegBtn');
      if(regBtnEl && regForm) {
        regBtnEl.addEventListener('click', function(e){
          console.log('[YOMI] YomiRegBtn clicked');
          // compute timestamp anyway for display/storage when confirm
          try {
            var now = new Date();
            var timestamp = now.toLocaleString('it-IT', { timeZone: 'UTC' }) + ' UTC';
            var tsField = document.getElementById('yomi-timestamp-note');
            if(tsField) tsField.value = timestamp;
          } catch (err) {}

          // run validation using a fake event (to allow yomiValidateRegister to call preventDefault)
          if(!window.yomiValidateRegister) return;
          var fakeEvent = { preventDefault: function(){} };
          var res = window.yomiValidateRegister(fakeEvent);
          if(res === true) {
            console.log('[YOMI] validation passed on Create Account click, switching to Preferences view');
            window._yomiPendingRegisterForm = regForm;
            if(!document.getElementById('YomiAccountDrawer').classList.contains('active')) {
              window.openAccountDrawer();
              setTimeout(function(){ window.yomiSwitch('Preferences'); }, 300);
            } else {
              window.yomiSwitch('Preferences');
            }
          }
        });
      }

      // Preferences confirm/cancel handlers
      var prefConfirm = document.getElementById('yomi-pref-confirm');
      var prefCancel = document.getElementById('yomi-pref-cancel');
      if(prefCancel) prefCancel.addEventListener('click', function(){ window.yomiSwitch('Register'); });
      // clear pref error when toggles change (only if element exists)
      ['pref-email-newsletter','pref-sms-marketing','pref-whatsapp-marketing','pref-privacy-required','pref-terms-required'].forEach(function(id){
        var el = document.getElementById(id); if(el) el.addEventListener('change', function(){ var pe = document.getElementById('YomiPrefError'); if(pe){ pe.textContent=''; pe.classList.remove('active'); pe.style.display='none'; } });
      });
        if(prefConfirm) prefConfirm.addEventListener('click', function(){
          console.log('[YOMI] yomi-pref-confirm clicked');
          // collect preferences first
          var emailPref = document.getElementById('pref-email-newsletter') ? document.getElementById('pref-email-newsletter').checked : false;
          var smsPref = document.getElementById('pref-sms-marketing') ? document.getElementById('pref-sms-marketing').checked : false;
          var waPref = document.getElementById('pref-whatsapp-marketing') ? document.getElementById('pref-whatsapp-marketing').checked : false;
          // privacy/terms checkboxes are optional and controlled by section settings
          var privacyEl = document.getElementById('pref-privacy-required');
          var termsEl = document.getElementById('pref-terms-required');
          var privacyOk = true;
          var termsOk = true;
          var _yomiCfgEl = document.getElementById('YomiAccountDrawer');
          var requirePrivacy = !!(_yomiCfgEl && _yomiCfgEl.dataset.requirePrivacy === 'true');
          var requireTerms = !!(_yomiCfgEl && _yomiCfgEl.dataset.requireTerms === 'true');
          if(requirePrivacy) privacyOk = privacyEl ? privacyEl.checked : false;
          if(requireTerms) termsOk = termsEl ? termsEl.checked : false;
          console.log('[YOMI] Collected prefs', { emailPref: emailPref, smsPref: smsPref, waPref: waPref, privacyOk: privacyOk, termsOk: termsOk });

        // If this preferences confirm was triggered after a social overlay click, save prefs and resume social flow
        if(window._yomiPendingSocial && window._yomiPendingSocial.iframe) {
          try { localStorage.setItem('yomi_pending_prefs', JSON.stringify({ emailPref: emailPref, smsPref: smsPref, waPref: waPref, privacyOk: privacyOk, termsOk: termsOk, ts: new Date().toISOString() })); } catch(e){}
          var sIframe = window._yomiPendingSocial.iframe;
          try {
            sIframe.style.pointerEvents = 'auto';
            sIframe.removeAttribute('data-yomi-disabled');
          } catch(e) {}
          try { var ov = sIframe.parentElement.querySelector('.yomi-social-overlay'); if(ov) ov.remove(); } catch(e){}
          try { var href = sIframe.getAttribute('src') || sIframe.src || ''; if(href) window.open(href, '_blank'); } catch(e){}
          delete window._yomiPendingSocial;
          try { window.yomiSwitch('Login'); } catch(e){}
          return;
        }

        // If there are missing required checkboxes, show inline error
        if(!privacyOk || !termsOk) {
          var pe = document.getElementById('YomiPrefError');
          if(pe) { pe.textContent = 'Please accept Privacy Policy and Terms & Conditions to continue.'; pe.classList.add('active'); pe.style.display = 'block'; pe.scrollIntoView({behavior: 'smooth', block: 'center'}); }
          return;
        }

        // If we have pending prefs stored for the logged-in user flow, and we're applying to an existing account,
        // submit an account update form with the stored prefs.
        if(window._yomiApplyPendingPrefsToLogged) {
          try {
            var updateForm = document.createElement('form');
            updateForm.method = 'post';
            updateForm.action = '/account';
            updateForm.style.display = 'none';
            function addHidden(name, value){ var i = document.createElement('input'); i.type='hidden'; i.name=name; i.value=value; updateForm.appendChild(i); }
            var now = new Date(); var timestamp = now.toLocaleString('it-IT', { timeZone: 'UTC' }) + ' UTC';
            addHidden('customer[note][Data Accettazione Termini]', timestamp);
            addHidden('customer[note][Privacy Policy]', privacyOk ? 'Accettata' : '');
            addHidden('customer[note][Terms and Conditions]', termsOk ? 'Accettati' : '');
            addHidden('customer[accepts_marketing]', emailPref ? 'true' : 'false');
            addHidden('customer[note][SMS_Marketing]', smsPref ? 'true' : 'false');
            addHidden('customer[note][WhatsApp_Marketing]', waPref ? 'true' : 'false');
            document.body.appendChild(updateForm);
            // remove stored pending prefs
            try { localStorage.removeItem('yomi_pending_prefs'); } catch(e){}
            updateForm.submit();
            return;
          } catch(e) {}
        }

        // Otherwise, proceed with the existing register form submission flow
        var form = window._yomiPendingRegisterForm || document.getElementById('YomiRegisterForm');
        if(!form) return;

        // set hidden fields (overwrite if present)
        function setOrCreateHidden(name, value) {
          var el = form.querySelector('input[name="' + name + '"]');
          if(!el) {
            el = document.createElement('input');
            el.type = 'hidden';
            el.name = name;
            form.appendChild(el);
          }
          el.value = value;
          console.log('[YOMI] set hidden field', name, value);
        }

        // timestamp (ensure latest)
        try {
          var now = new Date();
          var timestamp = now.toLocaleString('it-IT', { timeZone: 'UTC' }) + ' UTC';
        } catch (err) { var timestamp = ''; }
        setOrCreateHidden('customer[note][Data Accettazione Termini]', timestamp);
        setOrCreateHidden('customer[note][Privacy Policy]', privacyOk ? 'Accettata' : '');
        setOrCreateHidden('customer[note][Terms and Conditions]', termsOk ? 'Accettati' : '');
        // set iubenda-compatible hidden consent field
        setOrCreateHidden('privacy_consent_checkbox', (privacyOk ? 'accettato' : ''));
        setOrCreateHidden('customer[accepts_marketing]', emailPref ? 'true' : 'false');
        setOrCreateHidden('customer[note][SMS_Marketing]', smsPref ? 'true' : 'false');
        setOrCreateHidden('customer[note][WhatsApp_Marketing]', waPref ? 'true' : 'false');
        // finally submit (remove our submit interceptor to avoid loop)
        try {
          // mark form as confirmed so our submit interceptor allows the next submit
          form.dataset.yomiConfirmed = 'true';
          console.log('[YOMI] Form marked as confirmed, about to submit.');
          // --- INVIO DATI A IUBENDA ---
          try { if(typeof sendIubendaDrawerConsent === 'function') sendIubendaDrawerConsent(); } catch(e) { console.error('[YOMI] sendIubendaDrawerConsent error', e); }
          // ----------------------------
          // set creating state on register button and submit
          var regBtn = document.getElementById('YomiRegBtn');
          if(regBtn) { regBtn.textContent = 'CREATING ACCOUNT...'; regBtn.disabled = true; }
          // also disable confirm to avoid double clicks
          var confBtn = document.getElementById('yomi-pref-confirm'); if(confBtn) confBtn.disabled = true;
          // remove pending prefs cookie/localStorage in case
          try { localStorage.removeItem('yomi_pending_prefs'); } catch(e){}
          form.submit();
        } catch (err) {
          // fallback: dispatch native submit (flag remains set so handler allows it)
          var evt = document.createEvent('HTMLEvents'); evt.initEvent('submit', true, true); form.dispatchEvent(evt);
        }
      });

      // Expose a function to open preferences view after external/social login
      window.openAccountPreferences = function() {
        if(!document.getElementById('YomiAccountDrawer').classList.contains('active')) {
          window.openAccountDrawer();
          setTimeout(function(){ window.yomiSwitch('Preferences'); }, 300);
        } else {
          window.yomiSwitch('Preferences');
        }
      };
      // Legal modal open/close (used when policy links are not set in editor)
      window.openLegal = function(url) {
        try {
          var modal = document.getElementById('legalModal');
          var iframe = document.getElementById('legalIframe');
          if(!modal || !iframe) return;
          iframe.src = url;
          modal.style.display = 'block';
          document.body.style.overflow = 'hidden';
        } catch(e) {}
      };
      window.closeLegal = function() {
        try {
          var modal = document.getElementById('legalModal');
          var iframe = document.getElementById('legalIframe');
          if(!modal || !iframe) return;
          modal.style.display = 'none';
          iframe.src = '';
          document.body.style.overflow = '';
        } catch(e) {}
      };
      // Close modal when clicking outside content
      document.addEventListener('click', function(ev){
        try {
          var modal = document.getElementById('legalModal');
          if(!modal) return;
          if(ev.target === modal) window.closeLegal();
        } catch(e) {}
      });
      
      // Social login is handled by the installed app; do not intercept clicks or add overlays here.
      // Keep `.oxi-social-login` untouched so the social widget can manage its own events.
    });
    
    // === SWIPE E CLICK ESTERNO ===
    var touchStartX = 0;
    var touchStartY = 0;
    var touchStartTime = 0;
    var isInitialized = false;
    
    function initDrawerGestures() {
      if (isInitialized) return;
      isInitialized = true;
      
      var drawer = document.getElementById('YomiAccountDrawer');
      if (!drawer) return;
      
      var overlay = drawer.querySelector('.yomi-drw-overlay');
      var content = drawer.querySelector('.yomi-drw-content');
      
      // Click fuori dal content chiude (desktop e mobile)
      drawer.addEventListener('click', function(e) {
        var content = drawer.querySelector('.yomi-drw-content');
        if (content && !content.contains(e.target)) {
          window.closeAccountDrawer();
        }
      });
      
      // ESC chiude
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' || e.keyCode === 27) {
          var d = document.getElementById('YomiAccountDrawer');
          if (d && d.classList.contains('active')) {
            window.closeAccountDrawer();
          }
        }
      });
      
      // Swipe gesture per mobile
      if (content) {
        content.addEventListener('touchstart', function(e) {
          var d = document.getElementById('YomiAccountDrawer');
          if (!d || !d.classList.contains('active')) return;
          
          var tag = e.target.tagName.toLowerCase();
          if (tag === 'input' || tag === 'button' || tag === 'a' || tag === 'textarea' || tag === 'select') return;
          
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          touchStartTime = Date.now();
        }, { passive: true });
        
        content.addEventListener('touchend', function(e) {
          var d = document.getElementById('YomiAccountDrawer');
          if (!d || !d.classList.contains('active')) return;
          if (touchStartX === 0) return;
          
          var endX = e.changedTouches[0].clientX;
          var endY = e.changedTouches[0].clientY;
          var deltaX = endX - touchStartX;
          var deltaY = Math.abs(endY - touchStartY);
          var elapsed = Date.now() - touchStartTime;
          
          // Swipe verso destra per chiudere
          if (deltaX > 50 && deltaX > deltaY * 2 && elapsed < 600) {
            window.closeAccountDrawer();
          }
          
          touchStartX = 0;
          touchStartY = 0;
        }, { passive: true });
      }
    }
    
    // Inizializza quando il DOM e pronto
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDrawerGestures);
    } else {
      initDrawerGestures();
    }
    // After initial gestures/init, check if we have pending prefs for a logged-in user
    document.addEventListener('DOMContentLoaded', function(){
      try {
        var pending = localStorage.getItem('yomi_pending_prefs');
        var loggedEmailEl = document.querySelector('.yomi-drw-user-email');
        if(pending && loggedEmailEl) {
          var prefs = JSON.parse(pending);
          if(document.getElementById('pref-email-newsletter')) document.getElementById('pref-email-newsletter').checked = !!prefs.emailPref;
          if(document.getElementById('pref-sms-marketing')) document.getElementById('pref-sms-marketing').checked = !!prefs.smsPref;
          if(document.getElementById('pref-whatsapp-marketing')) document.getElementById('pref-whatsapp-marketing').checked = !!prefs.waPref;
          if(document.getElementById('pref-privacy-required')) document.getElementById('pref-privacy-required').checked = !!prefs.privacyOk;
          if(document.getElementById('pref-terms-required')) document.getElementById('pref-terms-required').checked = !!prefs.termsOk;
          window._yomiApplyPendingPrefsToLogged = true;
          window.openAccountDrawer();
          setTimeout(function(){ window.yomiSwitch('Preferences'); }, 300);
        }
      } catch(e){}
    });
  })();
